import {React} from 'common'
import RawTableRow from '@mui/material/TableRow'
import RawTableCell from '@mui/material/TableCell'
import {getValueTableByType} from 'services/utils/tableUtils'
import TableAction from './TableAction'
import {useTranslation} from 'react-i18next'
import TableCell from './TableCell'

const getValueFromTable = (tableRowData, key, keyTypes, externalKeys) => {
    const externalValues = externalKeys?.[key]?.reduce((acc, key) => {
        acc[key] = tableRowData?.[key]
        return acc
    }, {})
    const type = keyTypes?.[key] || keyTypes?.[key.key]
    if (typeof key === 'object') {
        return (
            getValueTableByType[type]?.(tableRowData[key.key]?.[key.value], externalValues) ||
            tableRowData[key.key]?.[key.value]
        )
    }
    return getValueTableByType[type]?.(tableRowData[key], externalValues) || tableRowData[key]
}

const getTranslateKey = (value, key, keyTranslate, t) => {
    if (keyTranslate?.[key] && value) {
        return t(`${keyTranslate[key]}.${value}`)
    }
    return value
}
const TableRow = ({
    tableRowData,
    isItemSelected,
    tableKeys,
    keyTranslate,
    externalKeys,
    rowClickAction,
    keyTypes,
    allowDelete,
    allowEdit,
    onClickDelete,
    onClickEdit,
    onClickExpand,
    expendedCell,
    children,
    itemName,
    tableName,
    tableActions,
}) => {
    const {t} = useTranslation()
    const itemId = tableRowData?._id || tableRowData?.id || tableRowData?.key
    const expended = expendedCell === itemId
    return (
        <>
            <RawTableRow
                hover
                role="checkbox"
                aria-checked={isItemSelected}
                tabIndex={-1}
                onClick={() => rowClickAction?.(tableRowData)}
                key={itemId}
                selected={isItemSelected}
                sx={{cursor: rowClickAction ? 'pointer' : 'auto'}}>
                {tableKeys.map((key) => (
                    <TableCell key={`table_cell_${key?.key || key}`} align="center">
                        {getTranslateKey(
                            getValueFromTable(tableRowData, key, keyTypes, externalKeys),
                            key,
                            keyTranslate,
                            t
                        )}
                    </TableCell>
                ))}
                <TableAction
                    itemId={itemId}
                    tableRowData={tableRowData}
                    allowDelete={allowDelete}
                    allowEdit={allowEdit}
                    onClickDelete={onClickDelete}
                    onClickEdit={onClickEdit}
                    onClickExpand={onClickExpand}
                    isExpanded={expended}
                    itemName={itemName}
                    tableName={tableName}
                    tableActions={tableActions}
                />
            </RawTableRow>
            {expended && (
                <RawTableRow>
                    <RawTableCell colSpan={tableKeys.length + 1} sx={{padding: 0}}>
                        {children}
                    </RawTableCell>
                </RawTableRow>
            )}
        </>
    )
}

export default TableRow
